module.exports = __webpack_public_path__ + "static/media/home.eeec2a22.svg";